(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-main-faq"] && !Shopify.designMode) return;
  try {
    
  var headers = document.getElementsByClassName("header");
  var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-slider"] && !Shopify.designMode) return;
  try {
    
  let slideIndex = 1;
  let timeoutId = 0;
  showSlides(slideIndex);
  setupButtons();
  setupDots();

  function setupButtons() {
    let prevs = document.getElementsByClassName("prev")
    let nexts = document.getElementsByClassName("next")
    for (i = 0; i < prevs.length; i++) {
      prevs[i].addEventListener("click", function(){ plusSlides(-1) });
    }
    for (n = 0; n < prevs.length; n++) {
      nexts[n].addEventListener("click", function(){ plusSlides(1) });
    }
  }

  function setupDots() {
    let dots = document.getElementsByClassName("dot")
    dots[0].addEventListener("click", function(){
      if (slideIndex != 1) {
        currentSlide(1);
      }
    });
    dots[1].addEventListener("click", function(){
      if (slideIndex != 2) {
        currentSlide(2);
      }
    });
  }

  // Next/previous controls
  function plusSlides(n) {
    showSlides(slideIndex += n);
  }

  // Thumbnail image controls
  function currentSlide(n) {
    showSlides(slideIndex = n);
  }

  function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("custom-slider-slide");
    let dots = document.getElementsByClassName("dot");
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";
    dots[slideIndex-1].className += " active";

    // Set timeout for autoplay
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      plusSlides(1);
    }, 5000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-crea-faq"] && !Shopify.designMode) return;
  try {
    
    var headers = document.getElementsByClassName("header");
  var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hercules-faq"] && !Shopify.designMode) return;
  try {
    
    var headers = document.getElementsByClassName("header");
    var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-faq"] && !Shopify.designMode) return;
  try {
    
    var headers = document.getElementsByClassName("header");
  var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-slider"] && !Shopify.designMode) return;
  try {
    
  let slideIndex = 1;
  let timeoutId = 0;
  showSlides(slideIndex);
  setupButtons();
  setupDots();

  function setupButtons() {
    let prevs = document.getElementsByClassName("prev")
    let nexts = document.getElementsByClassName("next")
    for (i = 0; i < prevs.length; i++) {
      prevs[i].addEventListener("click", function(){ plusSlides(-1) });
    }
    for (n = 0; n < prevs.length; n++) {
      nexts[n].addEventListener("click", function(){ plusSlides(1) });
    }
  }

  function setupDots() {
    let dots = document.getElementsByClassName("dot")
    dots[0].addEventListener("click", function(){
      if (slideIndex != 1) {
        currentSlide(1);
      }
    });
    dots[1].addEventListener("click", function(){
      if (slideIndex != 2) {
        currentSlide(2);
      }
    });
  }

  // Next/previous controls
  function plusSlides(n) {
    showSlides(slideIndex += n);
  }

  // Thumbnail image controls
  function currentSlide(n) {
    showSlides(slideIndex = n);
  }

  function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("slider-slide");
    let dots = document.getElementsByClassName("dot");
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";
    dots[slideIndex-1].className += " active";

    // Set timeout for autoplay
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      plusSlides(1);
    }, 5000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-nutrition-facts"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
  $('.new-nutrition-facts-card-image').click(function(e) {
    // Change Selector Here
    $(this).toggleClass('fullscreen');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-timer-artdash"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Data fissa di scadenza (modifica questa data secondo le tue necessità)
  const endDate = new Date('2025-12-20T23:59:59').getTime();
  
  function updateTimer() {
    const now = new Date().getTime();
    const distance = endDate - now;
    
    if (distance > 0) {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      document.getElementById('days').textContent = days.toString();
      document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
      document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');
      document.getElementById('seconds').textContent = seconds.toString().padStart(2, '0');
    } else {
      // Timer scaduto
      document.getElementById('days').textContent = '0';
      document.getElementById('hours').textContent = '00';
      document.getElementById('minutes').textContent = '00';
      document.getElementById('seconds').textContent = '00';
    }
  }
  
  // Aggiorna il timer ogni secondo
  updateTimer();
  setInterval(updateTimer, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
